<template>
  <div v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.component("Tab", {
  data: () => {
    return {
      isActive: true,
    };
  },
  mounted() {
    this.isActive = this.selected;
  },
  props: {
    isTab2: { Boolean },
    name: { required: true },
    selected: { default: false },
  },
});
</script>
